/* eslint-disable */
import * as Types from '../../../models/schema';

import { AdviceRequestFragment_BuyingAdviceRequest_DTO, AdviceRequestFragment_ScanAdviceRequest_DTO } from '../../../graphql/models/fragments';
import { gql } from '@apollo/client';
import { AdviceRequestFragmentDTO } from '../../../graphql/models/fragments';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetAdviceRequestVariablesDTO = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type GetAdviceRequestDTO = (
  { __typename?: 'Query' }
  & { adviceRequest: (
    { __typename?: 'BuyingAdviceRequest' }
    & AdviceRequestFragment_BuyingAdviceRequest_DTO
  ) | (
    { __typename?: 'ScanAdviceRequest' }
    & AdviceRequestFragment_ScanAdviceRequest_DTO
  ) }
);


export const GetAdviceRequestDocumentDTO = gql`
    query getAdviceRequest($id: String!) {
  adviceRequest(id: $id) {
    ...adviceRequestFragment
  }
}
    ${AdviceRequestFragmentDTO}`;

/**
 * __useGetAdviceRequest__
 *
 * To run a query within a React component, call `useGetAdviceRequest` and pass it any options that fit your needs.
 * When your component renders, `useGetAdviceRequest` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdviceRequest({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAdviceRequest(baseOptions: Apollo.QueryHookOptions<GetAdviceRequestDTO, GetAdviceRequestVariablesDTO>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdviceRequestDTO, GetAdviceRequestVariablesDTO>(GetAdviceRequestDocumentDTO, options);
      }
export function useGetAdviceRequestLazyQueryDTO(baseOptions?: Apollo.LazyQueryHookOptions<GetAdviceRequestDTO, GetAdviceRequestVariablesDTO>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdviceRequestDTO, GetAdviceRequestVariablesDTO>(GetAdviceRequestDocumentDTO, options);
        }
export type GetAdviceRequestHookResult = ReturnType<typeof useGetAdviceRequest>;
export type GetAdviceRequestLazyQueryDTOHookResult = ReturnType<typeof useGetAdviceRequestLazyQueryDTO>;
export type GetAdviceRequestQueryResultDTO = Apollo.QueryResult<GetAdviceRequestDTO, GetAdviceRequestVariablesDTO>;